import React from 'react';
import { useTenant } from '../../../context/TenantContext';

const DEFAULT_HEADING = 'Things people ask.';

export const UtilityFaq: React.FC = () => {
  const { tenant } = useTenant();
  const items = tenant?.branding.marketing?.faq ?? [];
  const filtered = items.filter(i => i.question?.trim() && i.answer?.trim());
  if (filtered.length === 0) return null;

  return (
    <section id="faq" className="util-faq py-20 bg-white border-b border-[var(--util-rule)]">
      <div className="max-w-[1320px] mx-auto px-6">
        <div className="grid md:grid-cols-[220px_1fr] gap-10 mb-12 items-start">
          <div className="font-util-mono text-[11px] uppercase tracking-[0.06em] text-[var(--util-ink-faint)] border-t-2 border-[var(--util-ink)] pt-3">
            <span className="block text-[var(--util-accent-ink)] mb-1.5 font-medium">§ 05</span>
            Questions
          </div>
          <div>
            <h2 className="font-util-sans text-3xl md:text-[44px] font-semibold tracking-[-0.025em] leading-[1.05] max-w-[24ch]">
              {DEFAULT_HEADING}
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-2 border-t border-[var(--util-rule)]">
          {filtered.map((item, i) => (
            <details
              key={i}
              className={`util-faq-item py-6 cursor-pointer border-b border-[var(--util-rule)] ${
                i % 2 === 0 ? 'md:pr-8 md:border-r md:border-[var(--util-rule)]' : 'md:pl-8'
              }`}
              {...(i === 0 ? { open: true } : {})}
            >
              <summary className="flex justify-between items-center font-semibold text-[16px] text-[var(--util-ink)]">
                <span>{item.question}</span>
                <span className="util-faq-marker font-util-mono text-[var(--util-accent)] text-[22px] font-normal transition-transform duration-200">
                  +
                </span>
              </summary>
              <p className="mt-3 text-[14px] text-[var(--util-ink-soft)] max-w-[56ch]">{item.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};
